import BaseModel from './BaseModel';

class RollOverConfig extends BaseModel {
  constructor(data = {}) {
    super(data);
    this.updateData(data)
  }

  updateData = (data) => {
    this.id = data.id;
    this.remaining_gte = data.remaining_gte || "";
    this.percent = data.percent || "";
    this.fixed = data.fixed || "";
    this.is_active = data.is_active === true ? true : data.is_active === false ? false : true;
    this.configurable_id = data.configurable_id || "";
    this.swapCreditOnEmiPayment = data.swapCreditOnEmiPayment;
  }

  toApiJson = () => {
    this.completeValidation();
    return {
      id: this.id,
      rollover_config: {
        remaining_gte: this.remaining_gte,
        percent: this.percent === '' ? 0 : this.percent,
        fixed: this.fixed === '' ? 0 : this.fixed,
        is_active: this.is_active,
        configurable_type: "LeaseOffer",
        configurable_id: this.configurable_id
      },
    }
  }

  toEditApiJson = () => {
    this.completeValidation();
    return {
      id: this.id,
      rollover_config: {
        remaining_gte: this.remaining_gte,
        percent: this.percent === '' ? 0 : this.percent,
        fixed: this.fixed === '' ? 0 : this.fixed,
        is_active: this.is_active
      },
    }
  }

  validations = (field) => {
    return {
      remaining_gte: () => {
        if(this[field] === "" || this[field] < 0) {
          this.errors.remaining_gte = "This field is required and cannot be blank.";
        } else if(parseInt(this[field]) < parseInt(this.fixed)){
          this.errors.remaining_gte = "Remaining swaps should be greater than fixed.";
        } else if(parseInt(this[field]) > parseInt(this.swapCreditOnEmiPayment)) {
          this.errors.remaining_gte = "Remaining swaps should be less than swap Credit On Emi Payment.";
        } else {
          delete this.errors.remaining_gte;
        }
      },
      percent: () => {
        if((this[field] === "" || this[field] <= 0) && (this.fixed === "" || this.fixed < 0)) {
          this.errors.percent = "This field is required and cannot be blank.";
        } else if((parseInt(this[field]) < 0 || parseInt(this[field]) > 100) && (this.fixed === "" || this.fixed < 0)) {
          this.errors.percent = "Enter valid percentage."
        } else {
          delete this.errors.percent;
        }
      },
      fixed: () => {
        if((this[field] === "" || this[field] <= 0) && (this.percent === "" || this.percent < 0)) {
          this.errors.fixed = "This field is required and cannot be blank.";
        } else if(parseInt(this[field]) > parseInt(this.remaining_gte)){
          this.errors.fixed = "Fixed swaps should be less than remaining.";
        } else {
          delete this.errors.fixed;
        }
      },
    }[field];
  }

  validate = (field) => {
    if(this.validations(field)) {
      this.validations(field)()
    }
  }
}

export default RollOverConfig;
